import { addProp } from "@pnp/odata";
import { _Item } from "../items/types.js";
import { Folder } from "./types.js";
addProp(_Item, "folder", Folder, "folder");
//# sourceMappingURL=item.js.map